import { render, staticRenderFns } from "./SessionDates.vue?vue&type=template&id=08b4b448"
import script from "./SessionDates.vue?vue&type=script&lang=js"
export * from "./SessionDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports